import { executeDeleteData, executeGetData, executePostData, executePutData } from '../../services/ApiBase';
import { ConfigUrl } from '../../auth/OidcConfig';

export interface CatalogueImage {
  id: number;
  name: string;
  baseUrl: string | null;
  imageUrl: string | null;
  thumbnailUrl: string | null;
  category: string | null;
  contentType: string | null;
  uploadedBy: string | null;
  isActive: boolean | null;
  createdDate: string | null;
  updatedDate: string | null;
  previewUrl: string | null;
  thumbnailPreviewUrl: string | null;
}

export interface CatalogueMetadataRequest {
  name: string;
  imageUrl: string;
  thumbnailUrl: string | null;
  category: string | null;
  contentType: string | null;
}

export const getCatalogueCategories = async (accessToken: string): Promise<string[]> => {
  const url = `${ConfigUrl.baseURL}/catalogue/categories`;
  const res = await executeGetData(url, accessToken);
  return res.ok ? (res.data as string[]) : [];
};

export const getCatalogueImages = async (
  accessToken: string,
  category?: string,
): Promise<CatalogueImage[]> => {
  const url = category
    ? `${ConfigUrl.baseURL}/catalogue/images?category=${encodeURIComponent(category)}`
    : `${ConfigUrl.baseURL}/catalogue/images`;
  const res = await executeGetData(url, accessToken);
  return res.ok ? (res.data as CatalogueImage[]) : [];
};

/** Returns a 15-minute write SAS URL for the given relative blob path. */
export const getCatalogueUploadSasUrl = async (
  path: string,
  accessToken: string,
): Promise<string | null> => {
  const url = `${ConfigUrl.baseURL}/catalogue/upload-url?path=${encodeURIComponent(path)}`;
  const res = await executeGetData(url, accessToken);
  return res.ok ? (res.data as { sasUrl: string }).sasUrl : null;
};

/** Saves DB metadata after the file has been PUT directly to Azure Blob Storage. */
export const saveCatalogueMetadata = async (
  dto: CatalogueMetadataRequest,
  accessToken: string,
): Promise<CatalogueImage | null> => {
  const url = `${ConfigUrl.baseURL}/catalogue/metadata`;
  const res = await executePostData(url, dto, accessToken);
  return res.ok ? (res.data as CatalogueImage) : null;
};

export const updateCatalogueImage = async (
  id: number,
  name: string,
  category: string,
  accessToken: string,
): Promise<CatalogueImage | null> => {
  const url = `${ConfigUrl.baseURL}/catalogue/image/${id}`;
  const res = await executePutData(url, { name, category }, accessToken);
  return res.ok ? (res.data as CatalogueImage) : null;
};

export const deleteCatalogueImage = async (
  id: number,
  accessToken: string,
): Promise<boolean> => {
  const url = `${ConfigUrl.baseURL}/catalogue/image/${id}`;
  const res = await executeDeleteData(url, accessToken);
  return res.ok;
};
